import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	true: {
		id: 'servicedesk-insight-attribute-views.boolean.true',
		defaultMessage: 'True',
		description: 'Select option text for CMDB inline editable boolean attribute true value.',
	},
	false: {
		id: 'servicedesk-insight-attribute-views.boolean.false',
		defaultMessage: 'False',
		description: 'Select option text for CMDB inline editable boolean attribute false value.',
	},
	none: {
		id: 'servicedesk-insight-attribute-views.boolean.none',
		defaultMessage: 'None',
		description: 'Select option text for CMDB inline editable boolean attribute none value.',
	},
});
